export enum VerificationType {
    ROUTINE = 'ROUTINE',
    TRAVEL = 'TRAVEL',
}